import {ImportStatus} from "../model/ImportStatus";

export class ImportStatusToIconConverter {
    static getIconPath = (status: ImportStatus) => {
        switch (status) {
            case ImportStatus.RUNNING:
                return '/app/images/icons/animated/gear.svg';
            case ImportStatus.SUCCEEDED:
                return '/app/images/icons/done-green.svg';
            case ImportStatus.FAILED:
                return '/app/images/icons/warning-orange.svg';
            default:
                throw 'Unknown ImportStatus' + status + '!';
        }
    };

    static getUiDescription = (status: ImportStatus): string => {
        switch (status) {
            case ImportStatus.RUNNING:
                return 'Import is running!';
            case ImportStatus.SUCCEEDED:
                return 'Import run succeeded';
            case ImportStatus.FAILED:
                return 'Import run failed';
            default:
                throw 'Unknown ImportStatus' + status + '!';
        }
    }
}